import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { Invoice } from "../../order/model/invoice.model";

export class SettlementInvoiceModel extends EntityBase {
  InvoiceId: number;
  SettlementId: number;
  NotDisplay: boolean;
  // Invoice:Invoice;
}
